
export default {
  props: {
    item: {
      required: true,
    },
  },

  components: {},
  auth: true,
  data() {
    return {
      form: {
        page: 1,
      },
      active: false,
    };
  },
  methods: {
    remove() {
      this.$axios.delete('/api/notices/' + this.item.id).then((response) => {
        this.$emit('removed', this.item);

        this.active = false;
      });
    },
  },

  computed: {
    isManager() {
      if (!this.$auth.user) return false;

      if (!this.$auth.hasScope('manager')) return false;

      if (this.$auth.user?.district.id != this.item.district.id) return false;

      return true;
    },
  },

  mounted() {},
};
